import SEO from "@/components/SEO";
import FormationsGrid from "@/components/sections/FormationsGrid";
import FAQ from "@/components/sections/FAQ";
import CTASection from "@/components/sections/CTASection";
import TrustSignals from "@/components/sections/TrustSignals";

export default function FormationsPage() {
  return (
    <>
      <SEO
        title="Catalogue des formations IA"
        description="Découvrez les 4 formations professionnelles YAFORMIS en intelligence artificielle : Initiation IA, outils IA, IA générative, agents IA. Éligibles CPF et OPCO."
        path="/formations"
      />
      <section className="bg-brand-page py-12 md:py-16 border-b border-brand-line" data-testid="formations-page-hero">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="overline">Catalogue 2026 · 2027</div>
          <h1 className="font-heading font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-3 leading-[1.05] text-brand-ink max-w-5xl">
            Quatre parcours pour <span className="text-brand-blue">monter en compétences</span> sur l'IA.
          </h1>
          <p className="mt-4 text-base md:text-lg text-slate-600 max-w-3xl leading-relaxed">
            Du débutant au niveau avancé, chaque formation est construite autour de cas d'usage réels et d'un projet appliqué à votre métier.
          </p>
        </div>
      </section>
      <FormationsGrid compact />
      <TrustSignals />
      <FAQ />
      <CTASection />
    </>
  );
}
